<template>
  <div>
    <div v-for="(item, index) in result.data" :key="`result-item-${index}`">
      <callout
        :border-color="getColor(item.paymentJournalStatusId)"
        class="mb-3 callout-extended"
        :has-toggle="false"
      >
        <div class="row mt-2 row-container">
          <div class="col-2 col-sm col-6 border-right status">
            <balloon
              :background-color="`bg-${getColor(item.paymentJournalStatusId)}`"
              class="mt-2 font-weight-normal font-16 d-flex justify-content-center align-items-center w-90 ml-3 mb-3 font-weight-bold"
              color="font-weight-bold"
              :text="item.paymentJournalStatusDesc"
            />
          </div>
          <div class="col-2 col-sm col-6 pl-3 pl-md-5 pl-sm-4 pt-1">
            <div class="color-secondary-6 font-14 font-weight-normal">
              Número de Jornal:
            </div>
            <span class="color-black font-16 font-weight-bold">
              {{ item.paymentJournalNumber }}
            </span>
          </div>
          <div
            class="col-md-12 border-top mx-2 mr-4 d-none d-md-none d-sm-block"
          />
          <div class="col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4 pt-1">
            <div class="color-secondary-6 font-14 font-weight-normal">
              Conteo de Pagos:
            </div>
            <span
              class="color-black font-16 font-weight-normal ml-0 ml-md-4 ml-sm-0 pl-0 pl-md-2 pl-sm-0"
            >
              {{ item.paymentCount }}
            </span>
          </div>
          <div class="col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4 pt-1">
            <div class="color-secondary-6 font-14 font-weight-normal">
              Total Pagado:
            </div>
            <span class="color-black font-16 font-weight-normal">
              {{ item.paymentTotalAmount | price }}
            </span>
          </div>
          <div class="col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4 pt-1">
            <div class="color-secondary-6 font-14 font-weight-normal">
              Fecha Creado:
            </div>
            <span class="color-black font-16 font-weight-normal">
              {{ item.createdDate | date }}
              <i>{{ item.createdDate | hour }}</i>
            </span>
          </div>
          <div
            class="col-2 col-sm col-6 text-center mt-4 mt-md-0 mt-sm-4 pr-5 pt-1"
          >
            <drop-down :data-item="{ item, index }" :items="actionItems" />
          </div>
        </div>
      </callout>
    </div>
    <pagination
      v-if="showPagination"
      :data="result.pagination"
      :page-size="15"
      :show-text="true"
      @pagination-go-page="onPageChange"
    />
  </div>
</template>

<script>
import Callout from 'custom-callout';
import Balloon from 'custom-balloon';
import DropDown from 'dropdown';
import Pagination from 'pagination';
import paymentJournalStatus from '@/utils/constants/paymentJournalStatus.js';
import _generalApi from '@/modules/app/api';
import { getJournalReport as _getJournalReport } from '@/modules/shared/scholarship.api.js';

export default {
  name: 'SearchResult',
  components: {
    Callout,
    Balloon,
    DropDown,
    Pagination,
  },
  props: {
    result: {
      type: Object,
      default: () => ({
        data: [],
        pagination: {},
      }),
    },
  },
  computed: {
    getColor() {
      return (status) => {
        switch (status) {
          case paymentJournalStatus.ArchivoGenerado:
            return 'secondary-23';
          case paymentJournalStatus.Procesado:
            return 'secondary-36';
          case paymentJournalStatus.Pagado:
            return 'green-light';
          default:
            return 'secondary-19';
        }
      };
    },
    actionItems() {
      return [
        {
          name: 'view details',
          label: 'Ver Detalle',
          icon: 'fas fa-file-search color-primary-1',
          click: ({ item: { academicYearId, paymentJournalId } }) => {
            this.$router.push({
              name: 'jornalDetails',
              params: {
                academicYearId,
                paymentJournalId,
              },
            });
          },
        },
        {
          name: 'print',
          label: 'Imprimir',
          icon: 'fas fa-print color-primary-1',
          click: (item) => {
            this.getReport(item);
          },
        },
      ];
    },
    showPagination() {
      return (
        this.result.data.length > 0 &&
        this.result.pagination.totalItemCount > this.result.pagination.perPage
      );
    },
  },
  methods: {
    onPageChange(page) {
      this.$emit('on-page-change', page);
    },
    async getReport(row) {
      if (row.item.paymentJournalId) {
        await _getJournalReport(row.item.paymentJournalId).then((response) => {
          _generalApi.ConvertToBlob(response.data);
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .callout-extended {
  .overflow-hidden {
    overflow: unset !important;
  }
}

@media only screen and (max-width: 768px) {
  .row-container {
    .status {
      border-right: unset !important;
    }
  }
}
</style>
